import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './contexts/ToastContext';
import reportWebVitals from './reportWebVitals';
import { bootstrapCognito } from './services/cognitoConfig';

const container = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(container);

// Load `/aws-config.json` first, then configure Amplify — otherwise login hits "Auth UserPool not configured"
void bootstrapCognito().finally(() => {
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <ToastProvider>
          <App />
        </ToastProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
